import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DashboardPopup from '../DashboardPopup'
import Button from 'components/UI/Button/Button'
import {
  Title,
  Note,
  ButtonRow
} from './PasswordChangedPopup.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class PasswordChangedPopup extends Component {
  static propTypes = {
    emails: PropTypes.arrayOf(PropTypes.string)
  }

  render () {
    return (
      <DashboardPopup
        onCancel={this.props.onCancel}
        isSettings
      >
        <Title>
          Success!
        </Title>
        <Note>
          Your password has been changed
        </Note>
        <ButtonRow>
          <Button
            bgColor={colors.lightBlue}
            color='white'
            size='regular'
            width='105px'
            height='30px'
            onClick={this.props.onCancel}
          >
            OK
          </Button>
        </ButtonRow>
      </DashboardPopup>
    )
  }
}
